import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as _ from "lodash";
import { isEmpty } from '../../common/helper';
import { ActionDefinition, ActionDefinitionSparePartReference, ActionPriority, ActionState, ActionStatus, ActionTopic, Thing, WorkOrder } from "../../model";
import { ActionDefinitionTypeService } from "../../service/action-definition-type.service";
import { AuthenticationService } from "../../service/authentication.service";
import { UserActionStatusService } from "../../service/user-action-status.service";
import { CustomPropertyFormComponent } from "../../shared/custom-property/custom-property-form.component";
import { ErrorUtility } from "../../utility/error-utility";
import { SparePartInputComponent } from "../action-info-dialog/spare-part-input.component";

@Component({
    selector: 'create-uncoded-action-dialog',
    template: require('./create-uncoded-action-dialog.component.html')
})
export class CreateUncodedActionDialogComponent {

    @ViewChild('form') form: NgForm;

    @ViewChild('customPropForm') customPropForm: CustomPropertyFormComponent;

    @ViewChild(SparePartInputComponent) sparePartInput: SparePartInputComponent;

    error: string;
    descriptionPlaceholder: string = "Enter a brief description of the action";
    loading: boolean;
    actionDefinitionTypes: { value: string, label: string }[];
    showSparePartInput: boolean;

    private thing: Thing;
    private isActive: boolean;
    private workOrder: WorkOrder;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<CreateUncodedActionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        @Inject(forwardRef(() => UserActionStatusService)) private userActionStatusService: UserActionStatusService,
        @Inject(forwardRef(() => ActionDefinitionTypeService)) private actionDefinitionTypeService: ActionDefinitionTypeService,
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService
    ) {
        this.thing = data.thing;
        this.isActive = data.isActive;
        this.workOrder = data.workOrder;
        this.showSparePartInput = this.authenticationService.getTenant().uncodedActionSparePartsEnabled;
        this.initActionDefinitionTypes();
    }

    private initActionDefinitionTypes(): void {
        this.actionDefinitionTypeService.getAllActionDefinitionTypes()
            .then(defs => this.actionDefinitionTypes = defs.map(d => { return { value: d.id, label: d.label } }).sort((a, b) => (a.label > b.label) ? 1 : -1)).catch(() => this.actionDefinitionTypes = [])
    }

    save(): void {
        let actionDefinition: ActionDefinition = (_.omitBy(this.form.form.getRawValue(), (field) => isEmpty(field)) as any);
        actionDefinition.name = actionDefinition.label;
        actionDefinition.topic = ActionTopic.MAINTENANCE;
        actionDefinition.priority = ActionPriority.NORMAL;
        let body: ActionStatus = {} as ActionStatus;
        body.thingId = this.thing.id;
        body.actionDefinition = actionDefinition;
        body.uncoded = true;
        body.state = ActionState.TODO;
        if (this.isActive && this.workOrder) {
            body.workOrderId = this.workOrder.id;
        }
        body.properties = this.customPropForm?.getProperties();
        if (this.sparePartInput) {
            let sparePartReferences: ActionDefinitionSparePartReference[] = [];
            const ref: ActionDefinitionSparePartReference = this.sparePartInput.getValue();
            if (ref.code) {
                sparePartReferences.push(ref);
            }
            body.actionDefinition.sparePartReferences = sparePartReferences.length ? sparePartReferences : null;
        }
        this.userActionStatusService.createActionStatus(body, !this.isActive).then(action => {
            this.dialogRef.close(action);
        }).catch(err => this.error = ErrorUtility.getMessage(err));
    }
}